export class ServiceClientUserAnswers {
    constructor(
        public idPregunta?: number,
        public idControl?: number
    ){} 
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/service-client-user-answers.model.ts